import { PromotionService } from './../../../../../services/promotion.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { IPromotion, Promotion } from '../../../../../models/promotion.model';
import { PromotionItemService } from '../../../../../services/promotionItem.service';
import { IPromotionItem, PromotionItem } from '../../../../../models/promotionItem.model';
import { TypeOfferService } from '../../../../../services/typeOffer.service';
import { ITypeOffer, TypeOffer } from '../../../../../models/typeOffer.model';
import { NameValidator } from '../../../validators/name.validator';
import { Location } from '@angular/common';
import { PostPromotionService } from '../../../../../services/postPromotion.service';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.scss']
})
export class PromotionComponent implements OnInit {
  @ViewChild('closebutton1') closebutton1;
  x_article_achete_y_article_offert = false;
  x_pourcent_de_reduction_produit  = false;
  livraison_gratuite = false;
  livraison_gratuite_x_montant = false;
  x_montant_reduit_sur_la_livraison_des_articles = false;
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
  x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
  x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;

  x_pourcent_de_reduction_service = false;
  frais_de_deplacement_gratuit = false;
  reduction_de_x_montant_sur_les_frais_de_deplacement = false;
  search: any;
  allPromotions: Promotion[] = [];
  allPromotionsTmp: Promotion[] = [];
  // @ts-ignore
  promotions: IPromotion[] = [];
  promotionitems : IPromotionItem[] = [];
  typeOfferItems : IPromotionItem[] = [];
  // @ts-ignore
  currentPromotion: IPromotion = [];
  page = 1;
  perPage = 10;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  isTrueName = false;
  offertypes: ITypeOffer[] = [];
  @ViewChild('closebutton') closebutton;

  constructor(private fb: FormBuilder, private promotionService: PromotionService ,
              private router :Router,private location: Location,
              private promotionItemService: PromotionItemService,
              private typeOfferService : TypeOfferService, private postPromotionService: PostPromotionService) { }

  ngOnInit(): void {
    this.loadPromotions();
    this.loadOfferTypes();
    
  }

  model = {
    description: ''
  };

  loadPromootionItems(){
    this.promotionItemService.getPromotionItems().subscribe(rs=>{
      this.promotionitems = rs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  promotionForm = this.fb.group({
    promotionForm0: this.fb.group({
      name : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    promotionForm1: this.fb.group({
      typeOffer : new FormControl("" , [Validators.required]),
    }),
     // x-pourcent-de-reduction
    promotionForm2: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),
    // Livraison-gratuite-x-montant
    promotionForm3: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-montant-reduit-sur-la-livraison-des-articles
    promotionForm4: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-article-achete-y-article-offert
    promotionForm5: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
    }),
    // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
    promotionForm6: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param2 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),

    promotionForm7: this.fb.group({
      description : new FormControl("" , [Validators.required, Validators.minLength(10)]),
    }),

    // promotionForm9: this.fb.group({
    //   isPromotionPublic : new FormControl('PUBLIC', []),
    // }),
  });

  get testName() {return this.promotionForm.get('promotionForm0.name');}
  get testName1() {return this.promotionFormEdite.get('promotionForm0.name');}
  get testTypeOffer() {return this.promotionForm.get('promotionForm1.typeOffer');}
  get testTypeOffer1() {return this.promotionFormEdite.get('promotionForm1.typeOffer');}
  // x-pourcent-de-reduction
  get testParam0Form2() {return this.promotionForm.get('promotionForm2.param0');}
  get testParam0Form21() {return this.promotionFormEdite.get('promotionForm2.param0');}
  // Livraison-gratuite-x-montant
  get testParam0Form3() {return this.promotionForm.get('promotionForm3.param0');}
  get testParam0Form31() {return this.promotionFormEdite.get('promotionForm3.param0');}
  // x-montant-reduit-sur-la-livraison-des-articles
  get testParam0Form4() {return this.promotionForm.get('promotionForm4.param0');}
  get testParam0Form41() {return this.promotionFormEdite.get('promotionForm4.param0');}
  // x-article-achete-y-article-offert
  get testParam0Form5() {return this.promotionForm.get('promotionForm5.param0');}
  get testParam0Form51() {return this.promotionFormEdite.get('promotionForm5.param0');}
  get testParam1Form5() {return this.promotionForm.get('promotionForm5.param1');}
  get testParam1Form51() {return this.promotionFormEdite.get('promotionForm5.param1');}
  // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
  get testParam0Form6() {return this.promotionForm.get('promotionForm6.param0');}
  get testParam0Form61() {return this.promotionFormEdite.get('promotionForm6.param0');}
  get testParam1Form6() {return this.promotionForm.get('promotionForm6.param1');}
  get testParam1Form61() {return this.promotionFormEdite.get('promotionForm6.param1');}
  get testParam2Form6() {return this.promotionForm.get('promotionForm6.param2');}
  get testParam2Form61() {return this.promotionFormEdite.get('promotionForm6.param2');}

  get testdescriptionForm7() {return this.promotionForm.get('promotionForm7.description');}

  get testFormMax() {return this.promotionFormEdite.get('promotionForm12.maximumNumberOfPurchases');}

  //get testisPromotionPublicForm9() {return this.promotionForm.get('promotionForm9.isPromotionPublic');}
  get testisPromotionPublicForm10() {return this.promotionFormEdite.get('promotionForm9.isPromotionPublic');}
  disableButton = true;
  loadOfferTypes(){
    this.typeOfferService.getTypeOffers().subscribe(rs=>{
      this.offertypes = rs;
    //  console.log(this.offertypes)
    });
  }

  selectedOfferType : TypeOffer;
  selectedOfferTypeSlug : any;
  typeOfferName = "";
  getOfferTypeById(id: any){
    this.typeOfferService.getIdTypeOffer(Number(id)).subscribe(rs=>{
      this.selectedOfferType = rs;
      this.typeOfferName = this.selectedOfferType?.name;
      //console.log("Type d'offre.........");
      //console.log(this.selectedOfferType);
      //console.log(this.typeOfferName);
      if(this.selectedOfferType != null && this.selectedOfferType !=undefined){
        this.selectedOfferTypeSlug = this.selectedOfferType?.slug;
        if(this.selectedOfferTypeSlug === "livraison-gratuite"){
          this.livraison_gratuite = true;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit = false;
          this.x_pourcent_de_reduction_service = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-pourcent-de-reduction-produit"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit = true;
          this.x_pourcent_de_reduction_service = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-pourcent-de-reduction-service"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit = false;
          this.x_pourcent_de_reduction_service = true;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "livraison-gratuite-a-partir-dun-x-montant-dachat"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = true;
          this.x_pourcent_de_reduction_service = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-montant-reduit-sur-la-livraison-des-articles"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit = false;
          this.x_pourcent_de_reduction_service = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = true;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-n-ieme-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit = false;
          this.x_pourcent_de_reduction_service = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = true;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-article-achete-y-article-offert"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service = false;
          this.x_article_achete_y_article_offert = true;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "frais-de-deplacement-gratuit"){
          this.livraison_gratuite = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_service = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = true;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "reduction-de-x-montant-sur-les-frais-de-deplacement"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = true;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service  = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = true;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = false;
        }else if(this.selectedOfferTypeSlug === "x-produit-achete-le-reste-a-y-pourcent-de-reduction"){
          this.livraison_gratuite = false;
          this.x_pourcent_de_reduction_service = false;
          this.x_article_achete_y_article_offert = false;
          this.x_pourcent_de_reduction_produit  = false;
          this.livraison_gratuite_x_montant = false;
          this.x_montant_reduit_sur_la_livraison_des_articles = false;
          this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction = false;
          this.frais_de_deplacement_gratuit = false;
          this.reduction_de_x_montant_sur_les_frais_de_deplacement = false;
          this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction = false;
          this.x_produit_achete_le_reste_a_y_pourcent_de_reduction = true;
        }
      }
    });
  } 

  promotionEditVisibilityForm = this.fb.group({
    maximumNumberOfPurchases : new FormControl("" , [Validators.required, Validators.pattern("^[0-9]*$")]), 
    //TODO publicPromotionVisibility
    publicPromotionVisibility : new FormControl("", []),
    
  });
    promoNumberMaxAchat: number
     onEditpublicPromotionVisibility(id: any) {
    this.promotionService.getIdPromotion(id).subscribe(rs => {
      // console.log("Promotion à modifier")
      // console.log("rs",rs)
      this.currentPromotion = rs;
     if(this.currentPromotion.publicPromotionVisibility == null) {
      this.currentPromotion.publicPromotionVisibility = false
     }

     if(this.currentPromotion.isApplyToAll == null) {
      this.currentPromotion.isApplyToAll = false
     }
      this.promoNumberMaxAchat = this.currentPromotion.maximumNumberOfPurchases;
      this.promotionEditVisibilityForm = this.fb.group({
        maximumNumberOfPurchases : new FormControl(this.currentPromotion.maximumNumberOfPurchases, []), 
        //TODO publicPromotionVisibility
        publicPromotionVisibility : new FormControl(this.currentPromotion?.publicPromotionVisibility, []),
        isApplyToAll : new FormControl(this.currentPromotion?.isApplyToAll, []),
      });
      
    });

   // console.log("this.currentPromotion", this.currentPromotion)
  }
  get getpublicPromotionVisibility() { return this.promotionEditVisibilityForm.controls; }

  get getPost() { return this.postPromotionForm.controls; }

  postPromotionForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required]),
    endDate : new FormControl("" , [Validators.required]),
    maximumNumberOfPurchases : new FormControl("" , [Validators.pattern("^[0-9]+$"),  Validators.min(0)   ]   ), 
    //TODO publicPromotionVisibility
    publicPromotionVisibility : new FormControl('false', []),
    isApplyToAll : new FormControl('false', []),
    
  });

 numericValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
  
      if (isNaN(value)) {
        return { notNumeric: true };
      }

      return null;
    };
  }
  
  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  getSelectedDate() {
    this.selectedStartDate = this.postPromotionForm.get('startDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }
  }

  showPicker: boolean = true;
  selectedDateTime: string | null = null;

  closePicker() {
    // Handle any logic you need with the selectedDateTime
    this.showPicker = false;
  }

  closeDatetimePicker(inputElement: ElementRef) {
      inputElement.nativeElement.blur();
  }

  getSelectedEndDate() {
    const startDateString = this.postPromotionForm.get('startDate')?.value;
    const endDateString = this.postPromotionForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }

  selectedPromotion: Promotion;
  getPromotion(promo: any){
    this.promotionService.getIdPromotion(promo.id).subscribe(rs =>{
      this.selectedPromotion = rs;
      //console.log("Promotion sélectionné...");
     // console.log(this.selectedPromotion);
      if(this.selectedPromotion != undefined && this.selectedPromotion.promotionItem){
        this.getOfferTypeById(this.selectedPromotion?.promotionItem[0]?.typeOffer?.id);
      }
    })
  }

  onPromotionFormSubmit(){

    if(this.promotionForm.controls.promotionForm0.invalid){
      this.promotionForm.controls.promotionForm0.markAllAsTouched();
      this.promotionForm.controls.promotionForm1.markAsUntouched();
      this.promotionForm.controls.promotionForm2.markAsUntouched();
      this.promotionForm.controls.promotionForm3.markAsUntouched();
      this.promotionForm.controls.promotionForm4.markAsUntouched();
      this.promotionForm.controls.promotionForm5.markAsUntouched();
      this.promotionForm.controls.promotionForm6.markAsUntouched();
      this.promotionForm.controls.promotionForm7.markAsUntouched();
      return;
    }
    if(this.promotionForm.controls.promotionForm0.valid &&
      this.promotionForm.controls.promotionForm1.valid  &&
      this.promotionForm.controls.promotionForm7.valid  &&
      this.livraison_gratuite || this.frais_de_deplacement_gratuit){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
      promotionItem.typeOffer = this.selectedOfferType;
      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";
      if(this.livraison_gratuite){
        promotionItem.name = form.name+" "+" livraison gratuite.";
      }
      if(this.frais_de_deplacement_gratuit){
        promotionItem.name = form.name+" "+" frais de déplacement gratuit.";
      }
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
     // console.log("Promo enregistrer avec livraison gratuite...");
     // console.log(promo);
    //  let isPublic = this.promotionForm.controls['promotionForm9'].value;
    //  promo.publicPromotionVisibility = isPublic.isPromotionPublic
    //   console.log("isPublic", isPublic)
    //   console.log("promo", promo)

      
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm2.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_pourcent_de_reduction_produit || this.x_pourcent_de_reduction_service){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm2'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
      // promotion publique ou non
      // let isPublic = this.promotionForm.controls['promotionForm9'].value;
      // promo.publicPromotionVisibility = isPublic.isPromotionPublic
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;

      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";

      if(this.x_pourcent_de_reduction_produit){
        promotionItem.name = form.name+" "+" Réduction de "+form2.param0 +" %";
      }
      if(this.x_pourcent_de_reduction_service){
        promotionItem.name = form.name+" "+" Réduction de "+form2.param0 +" % sur le service.";
      }
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
      //console.log("Promo enregistrer avec x_pourcent_de_reduction...");
      //console.log(promo);
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm3.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.livraison_gratuite_x_montant){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm3'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
       // promotion publique ou non
      //  let isPublic = this.promotionForm.controls['promotionForm9'].value;
      //  promo.publicPromotionVisibility = isPublic.isPromotionPublic
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;

      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";

      promotionItem.name = form.name+" "+" livraison gratuite à partir de "+form2.param0 +" FCFA acheté.";
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
     // console.log("Promo enregistrer avec livraison_gratuite_x_montant...");
     // console.log(promo);
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm4.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_montant_reduit_sur_la_livraison_des_articles){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm4'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
       // promotion publique ou non
      //  let isPublic = this.promotionForm.controls['promotionForm9'].value;
      //  promo.publicPromotionVisibility = isPublic.isPromotionPublic
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;

      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";

      promotionItem.name = form.name+" "+form2.param0 +" FCFA réduit sur la livraison des articles.";
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
     // console.log("Promo enregistrer avec x_montant_reduit_sur_la_livraison_des_articles...");
      //console.log(promo);
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm5.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_article_achete_y_article_offert || this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm5'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
       // promotion publique ou non
      //  let isPublic = this.promotionForm.controls['promotionForm9'].value;
      //  promo.publicPromotionVisibility = isPublic.isPromotionPublic
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;

      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";

      if(this.x_article_achete_y_article_offert){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s) "+form2.param1+" articles(s) offert(s)";
      }
      if(this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s) "+" le reste à "+form2.param1 +"de réduction.";
      }
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
     // console.log("Promo enregistrer avec x_article_achete_y_article_offert...");
     // console.log(promo);
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
             this.promotionForm.controls.promotionForm1.valid &&
             this.promotionForm.controls.promotionForm6.valid &&
             this.promotionForm.controls.promotionForm7.valid &&
             this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction || this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
      let promotionItems: PromotionItem[] = [];
      let promo = new Promotion();
      let promotionItem = new PromotionItem();
      let form = this.promotionForm.controls['promotionForm0'].value;
      let form2 = this.promotionForm.controls['promotionForm6'].value;
      let form7 = this.promotionForm.controls['promotionForm7'].value;
       // promotion publique ou non
      //  let isPublic = this.promotionForm.controls['promotionForm9'].value;
      //  promo.publicPromotionVisibility = isPublic.isPromotionPublic
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;
      promotionItem.value2 = form2.param2;

      promo.name = form.name;
      promo.description = form7.description;
      promo.type = "Kahpoo";

      if(this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s) et le "+form2.param1+" articles(s) à "+form2.param2+"% de réduction";
      }
      if(this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s), les "+form2.param1+" suivants à "+form2.param2+"% de réduction";
      }
      promotionItems.push(promotionItem);
      promo.promotionItem = promotionItems;
      //console.log("Promo enregistrer avec x_produit_achete_n_ieme_a_y_pourcent_de_reduction...");
      //console.log(promo);
      this.promotionService.savePromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été ajoutée avec succès',
          showConfirmButton: false,
          timer: 1500
        });
        this.close();
        this.loadPromotions();
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionForm.controls.promotionForm0.valid &&
      this.promotionForm.controls.promotionForm1.valid &&
      this.promotionForm.controls.promotionForm4.valid &&
      this.promotionForm.controls.promotionForm7.valid &&
      this.reduction_de_x_montant_sur_les_frais_de_deplacement){
        let promotionItems: PromotionItem[] = [];
        let promo = new Promotion();
        let promotionItem = new PromotionItem();
        let form = this.promotionForm.controls['promotionForm0'].value;
        let form2 = this.promotionForm.controls['promotionForm4'].value;
        let form7 = this.promotionForm.controls['promotionForm7'].value;
         // promotion publique ou non
        // let isPublic = this.promotionForm.controls['promotionForm9'].value;
        // promo.publicPromotionVisibility = isPublic.isPromotionPublic
        promotionItem.typeOffer = this.selectedOfferType;
        promotionItem.value0 = form2.param0;

        promo.name = form.name;
        promo.description = form7.description;
        promo.type = "Kahpoo";

        promotionItem.name = form.name+"Réduction de "+form2.param0 +" FCFA sur les frais de déplacement.";
        promotionItems.push(promotionItem);
        promo.promotionItem = promotionItems;
       // console.log("Promo enregistrer avec reduction_de_x_montant_sur_les_frais_de_deplacement...");
       // console.log(promo);
        this.promotionService.savePromotion(promo).subscribe(rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La promotion a été ajoutée avec succès',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadPromotions();
          this.reloadComponent();
        }, error => {
         // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 1500
          });
        });
    }
  }

  isoequalstoname = false;
  verifyPromotionName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  x_article_achete_y_article_offert1 = "x-article-achete-y-article-offert";
  x_pourcent_de_reduction_produit1 = "x-pourcent-de-reduction-produit";
  x_pourcent_de_reduction_service1 = "x-pourcent-de-reduction-service";
  frais_de_deplacement_gratuit1 = "frais-de-deplacement-gratuit";
  livraison_gratuite1 = "livraison-gratuite";
  livraison_gratuite_x_montant1 = "livraison-gratuite-a-partir-dun-x-montant-dachat";
  x_montant_reduit_sur_la_livraison_des_articles1 = "x-montant-reduit-sur-la-livraison-des-articles";
  x_produit_achete_n_ieme_a_y_pourcent_de_reduction1 = "x-produit-achete-n-ieme-a-y-pourcent-de-reduction";
  x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction1 = "x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction";
  x_produit_achete_le_reste_a_y_pourcent_de_reduction1 = "x-produit-achete-le-reste-a-y-pourcent-de-reduction";
  reduction_de_x_montant_sur_les_frais_de_deplacement1 = "reduction-de-x-montant-sur-les-frais-de-deplacement";
  onViewPromo(promoid: any) {
    this.promotionService.getIdPromotion(promoid).subscribe(promo =>  {
      this.currentPromotion = promo;
    //  console.log("Détails promo.....");
    //  console.log(this.currentPromotion);
    });
  }

  promotionFormEdite = this.fb.group({
    promotionForm0: this.fb.group({
      name : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
    }),
    promotionForm1: this.fb.group({
      typeOffer : new FormControl("" , [Validators.required]),
    }),
     // x-pourcent-de-reduction
    promotionForm2: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),
    // Livraison-gratuite-x-montant
    promotionForm3: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-montant-reduit-sur-la-livraison-des-articles
    promotionForm4: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
    }),
    // x-article-achete-y-article-offert
    promotionForm5: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
    }),
    // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
    promotionForm6: this.fb.group({
      param0 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param1 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
      param2 : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
    }),

    promotionForm7: this.fb.group({
      description : new FormControl("" , [Validators.required, Validators.minLength(10)]),
    }),

    promotionForm9: this.fb.group({
      isPromotionPublic : new FormControl("" , []),
    }),

    promotionForm11: this.fb.group({
      isApplyToAll : new FormControl("" , []),
    }),

    promotionForm12: this.fb.group({
      maximumNumberOfPurchases : new FormControl("" , [Validators.required,
        Validators.pattern("^[0-9]+$")]),
    }),
    promotionForm8: this.fb.group({
      startDate : new FormControl("" , []),
      endDate : new FormControl("" , []),
    }),
  });

  promotionFormMaxNumberAchat = this.fb.group({
    maximumNumberOfPurchases:  new FormControl("" , [Validators.required,
      Validators.pattern("^[0-9]+$")]),
  })

  promoStatus = false;
  onEditPromotion(id: any) {
    this.promotionService.getIdPromotion(id).subscribe(rs => {
      // console.log("Promotion à modifier")
      // console.log("rs",rs)
      this.currentPromotion = rs;
     if(this.currentPromotion.publicPromotionVisibility == null) {
      this.currentPromotion.publicPromotionVisibility = false
     }

     if(this.currentPromotion.maximumNumberOfPurchases == null) {
      this.currentPromotion.maximumNumberOfPurchases = 0
     }
    
     if(this.currentPromotion.isApplyToAll == null) {
      this.currentPromotion.isApplyToAll = false
     }
      this.promoStatus = this.currentPromotion.status;
      this.model.description = this.currentPromotion.description;
      this.getOfferTypeById(this.currentPromotion.promotionItem[0].typeOffer.id);
      this.promotionFormEdite = this.fb.group({
        promotionForm0: this.fb.group({
          name : new FormControl(this.currentPromotion?.name , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
        }),

        promotionForm1: this.fb.group({
          typeOffer : new FormControl(this.currentPromotion.promotionItem[0].typeOffer.id , [Validators.required]),
          // typeOfferName : new FormControl("" , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.notOnlyNumber ,NameValidator.checkValidOnlyLetterOrNumber, Validators.minLength(2), Validators.maxLength(100)]),
        }),

        // x-pourcent-de-reduction
        promotionForm2: this.fb.group({
          param0 : new FormControl(this.currentPromotion.promotionItem[0].value0 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
        }),

        // Livraison-gratuite-x-montant
        promotionForm3: this.fb.group({
          param0 : new FormControl(this.currentPromotion.promotionItem[0].value0 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
        }),

        // x-montant-reduit-sur-la-livraison-des-articles
        promotionForm4: this.fb.group({
          param0 : new FormControl(this.currentPromotion.promotionItem[0].value0 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(3), Validators.maxLength(8)]),
        }),

        // x-article-achete-y-article-offert
        promotionForm5: this.fb.group({
          param0 : new FormControl(this.currentPromotion.promotionItem[0].value0 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
          param1 : new FormControl(this.currentPromotion.promotionItem[0].value1 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(8)]),
        }),

        // x-produit-achete-n-ieme-a-y-pourcent-de-reduction
        promotionForm6: this.fb.group({
          param0 : new FormControl(this.currentPromotion.promotionItem[0].value0 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
          param1 : new FormControl(this.currentPromotion.promotionItem[0].value1 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
          param2 : new FormControl(this.currentPromotion.promotionItem[0].value2 , [Validators.required,NameValidator.notOnlyWhitespace,NameValidator.checkOnlyNumberValidator, Validators.minLength(1), Validators.maxLength(3)]),
        }),

        promotionForm7: this.fb.group({
          description : new FormControl(this.currentPromotion?.description ,  [Validators.required, Validators.minLength(10)]),
        }),

        promotionForm9: this.fb.group({
          isPromotionPublic : new FormControl(this.currentPromotion?.publicPromotionVisibility ,  []),
        }),

        promotionForm11: this.fb.group({
          isApplyToAll : new FormControl(this.currentPromotion?.isApplyToAll ,  []),
        }),

        promotionForm12: this.fb.group({
          maximumNumberOfPurchases : new FormControl(this.currentPromotion?.maximumNumberOfPurchases ,  []),
        }),

        promotionForm8: this.fb.group({
          startDate : new FormControl(this.currentPromotion.startDate , []),
          endDate : new FormControl(this.currentPromotion.endDate , []),
        }),
      });
    });

    // console.log("this.currentPromotion", this.currentPromotion)
  }

  getIfIsProductPromotionActive(promotion:any[]){
    let isProducPromotion = false;
    promotion.forEach(element=>{
      if((element.promotionItem[0].typeOffer.slug == 'livraison-gratuite' || element.promotionItem[0].typeOffer.slug == 'x-pourcent-de-reduction-produit' ||
         element.promotionItem[0].typeOffer.slug == 'livraison-gratuite-a-partir-dun-x-montant-dachat' || element.promotionItem[0].typeOffer.slug == 'x-montant-reduit-sur-la-livraison-des-articles' ||
         element.promotionItem[0].typeOffer.slug == 'x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction' || element.promotionItem[0].typeOffer.slug == 'x-produit-achete-le-reste-a-y-pourcent-de-reduction' ||
         element.promotionItem[0].typeOffer.slug == 'x-produit-achete-n-ieme-a-y-pourcent-de-reduction' || element.promotionItem[0].typeOffer.slug == 'x-article-achete-y-article-offert') && element.status){
          isProducPromotion = true;
      }
    });
    if(isProducPromotion){
      return true;
    }else {
      return false;
    }
  }

  getIfIsServicePromotionActive(promotion:any[]){
    let isServicePromotion = false;
    promotion.forEach(element=>{
      if((element.promotionItem[0].typeOffer.slug == 'x-pourcent-de-reduction-service' || element.promotionItem[0].typeOffer.slug == 'frais-de-deplacement-gratuit' ||
         element.promotionItem[0].typeOffer.slug == 'reduction-de-x-montant-sur-les-frais-de-deplacement') && element.status){
          isServicePromotion = true;
      }
    });
    if(isServicePromotion){
      return true;
    }else {
      return false;
    }
  }

  validateStartDates(startDate: any): string | null {
    const currentDate = new Date();
    const startDateTime = new Date(startDate);
    const oneHourInMilliseconds = 60 * 60 * 1000;
    if (startDateTime.getTime() - currentDate.getTime() >= oneHourInMilliseconds) {
      return 'La date de début est supérieure d\'une heure ou plus à la date d\'aujourd\'hui';
    }
    return null;
  }

  validateEndDates(endDate: any): string | null {
    const currentDate = new Date();
    const endDateTime = new Date(endDate);

    if (endDateTime < currentDate) {
      return 'La date de fin est dépassée';
    }
    return null;
  }

  enableKahpooPromotion(promo:Promotion){
    let verifStartDate = this.validateStartDates(promo.startDate);
    let verifEndDate = this.validateEndDates(promo.endDate);
   // console.log(promo)
      if(promo.endDate == null || promo.startDate == null){
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veillez définir une date de début et une date de fin pour cette promotion.',
          showConfirmButton: false,
          timer: 5500
        });
      }else{
        if(verifStartDate != null){
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'La date de début n\'est pas encore arrivée.',
            showConfirmButton: false,
            timer: 5500
          });
        }else if(verifEndDate != null){
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'La date de fin est dépassée.',
            showConfirmButton: false,
            timer: 5500
          });
        }
        if(verifStartDate == null && verifEndDate == null){
          Swal.fire({
            title: 'Voulez-vous activer cette promotion ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: 'Non',
            confirmButtonText: 'Oui'
          }).then((result) => {
            if (result.isConfirmed) {
              this.postPromotionService.enableKahpooPromotion(promo?.id).subscribe(
                rs=> {
                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Votre promotion a été activée avec succés.',
                    showConfirmButton: false,
                    timer: 3000
                  });
                  this.reloadComponent();
                }, error => {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.error.errorMessage,
                    showConfirmButton: false,
                    timer: 3000
                  })
                }
              )
            }
          })
        }
      }
    

    //console.log(promo)
  }
  disableKahpooPromotion(promo:Promotion){
    Swal.fire({
      title: 'Voulez-vous désactiver cette promotion ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromotionService.disableKahpooPromotion(promo?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Votre promotion a été désactivée avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
        })
      }
    })
  }
    isApplyToAllStatus: boolean = true
    isApplyToAllStatusProduct: boolean = true
    isApplyToAllStatusService: boolean = true
  loadPromotions() {
    this.promotionService.getKahpooPromotions().subscribe((data: any) => {
      this.allPromotions = data.content;
      this.allPromotionsTmp = data.content;
      // console.log("Liste des promotions...");
      // console.log(this.allPromotions);

      this.isApplyToAllStatusService = this.allPromotions.some((promotion: any) => promotion.isApplyToAll === true && (
        promotion.promotionItem[0].typeOffer.slug.includes("x-pourcent-de-reduction-service") ||
        promotion.promotionItem[0].typeOffer.slug.includes("frais-de-deplacement-gratuit") ||
        promotion.promotionItem[0].typeOffer.slug.includes("reduction-de-x-montant-sur-les-frais-de-deplacement")
       

      ));
      
      this.isApplyToAllStatusProduct = this.allPromotions.some((promotion: any) => promotion.isApplyToAll === true && (
        promotion.promotionItem[0].typeOffer.slug.includes("x-montant-reduit-sur-la-livraison-des-articles") ||
        promotion.promotionItem[0].typeOffer.slug.includes("livraison-gratuite-a-partir-dun-x-montant-dachat") ||
        promotion.promotionItem[0].typeOffer.slug.includes("x-pourcent-de-reduction-produit") ||
        promotion.promotionItem[0].typeOffer.slug.includes("x-produit-achete-le-reste-a-y-pourcent-de-reduction") ||
        promotion.promotionItem[0].typeOffer.slug.includes("x-produit-achete-n-ieme-a-y-pourcent-de-reduction") ||
        promotion.promotionItem[0].typeOffer.slug.includes("x-produit-achete-les-n-suivants-a-y-pourcent-de-reduction")
        
        

      ));
        
      // console.log("Liste des promotions...");
      // console.log("Condition isApplyToAllStatusProduct.", this.isApplyToAllStatusProduct);
      // console.log("Condition isApplyToAllStatusService.", this.isApplyToAllStatusService);
      }, (err) => {
        // console.log('-----> err', err);
    });
  }

  onEditPromotionFormSubmit(){
    if(this.promotionFormEdite.controls.promotionForm0.invalid){
      this.promotionFormEdite.controls.promotionForm0.markAllAsTouched();
      this.promotionFormEdite.controls.promotionForm1.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm2.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm3.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm4.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm5.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm6.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm7.markAsUntouched();
      this.promotionFormEdite.controls.promotionForm12.markAsUntouched();
      return;
    }
    if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
      this.promotionFormEdite.controls.promotionForm1.valid  &&
      this.promotionFormEdite.controls.promotionForm7.valid  &&
      this.livraison_gratuite || this.frais_de_deplacement_gratuit){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      promotionItem.typeOffer = this.selectedOfferType;
      updatedPromotion.promotionItem = promotionItems;
      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      //Vérifier si la promotion est activée
      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      if(this.livraison_gratuite){
        promotionItem.name = form.name+" "+" livraison gratuite.";
      }
      if(this.frais_de_deplacement_gratuit){
        promotionItem.name = form.name+" "+" frais de déplacement gratuit.";
      }
      promotionItems.push(promotionItem);
      // console.log("Promo modifiée avec livraison gratuite...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès..',
          showConfirmButton: false,
          timer: 1500
        });
        this.close1();

        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm2.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.x_pourcent_de_reduction_produit || this.x_pourcent_de_reduction_service){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();
      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm2'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      if(this.x_pourcent_de_reduction_produit){
        promotionItem.name = form.name+" "+" Réduction de "+form2.param0 +" %";
      }
      if(this.x_pourcent_de_reduction_service){
        promotionItem.name = form.name+" "+" Réduction de "+form2.param0 +" % sur le service.";
      }
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);
      updatedPromotion.promotionItem = promotionItems;
      // console.log("Promo modifiée avec x_pourcent_de_reduction...");
      // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès..',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm3.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.livraison_gratuite_x_montant){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm3'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      promotionItem.name = form.name+" "+" livraison gratuite à partir de "+form2.param0 +" FCFA acheté.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      //console.log("Promo Modifié avec livraison_gratuite_x_montant...");
      //console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm4.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.x_montant_reduit_sur_la_livraison_des_articles){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm4'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      promotionItem.name = form.name+" "+form2.param0 +" FCFA réduit sur la livraison des articles.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      //console.log("Promo modifiée avec x_montant_reduit_sur_la_livraison_des_articles...");
      //console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm5.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.x_article_achete_y_article_offert || this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm5'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      if(this.x_article_achete_y_article_offert){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s)"+form2.param1+" articles(s) offert(s)";
      }
      if(this.x_produit_achete_le_reste_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s)"+" le reste à "+form2.param1 +"de réduction.";
      }
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
      //console.log("Promo modifiée avec x_article_achete_y_article_offert...");
      //console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm6.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction || this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm6'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      if(this.promoStatus){
        let formDate = this.promotionFormEdite.controls['promotionForm8'].value;
        updatedPromotion.startDate = formDate.startDate;
        updatedPromotion.endDate = formDate.endDate;
      }

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      if(this.x_produit_achete_n_ieme_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s) et le "+form2.param1+" articles(s) à "+form2.param2+"% de réduction";
      }
      if(this.x_produit_achete_les_n_suivants_a_y_pourcent_de_reduction){
        promotionItem.name = form.name+" "+form2.param0 +" articles(s) acheté(s), les "+form2.param1+" suivants à "+form2.param2+"% de réduction";
      }
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItem.value1 = form2.param1;
      promotionItem.value2 = form2.param2;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
     // console.log("Promo modifiée avec x_produit_achete_n_ieme_a_y_pourcent_de_reduction...");
     // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }else if(this.promotionFormEdite.controls.promotionForm0.valid && this.promotionFormEdite.controls.promotionForm12.valid &&
             this.promotionFormEdite.controls.promotionForm1.valid &&
             this.promotionFormEdite.controls.promotionForm4.valid &&
             this.promotionFormEdite.controls.promotionForm7.valid &&
             this.reduction_de_x_montant_sur_les_frais_de_deplacement){
      let updatedPromotion = this.currentPromotion;
      let promotionItems: PromotionItem[] = [];
      let promotionItem = new PromotionItem();

      let form = this.promotionFormEdite.controls['promotionForm0'].value;
      let form2 = this.promotionFormEdite.controls['promotionForm4'].value;
      let form7 = this.promotionFormEdite.controls['promotionForm7'].value;

      if(this.promoStatus){
        let formDate = this.promotionForm.controls['promotionForm8']?.value;
        updatedPromotion.startDate = formDate?.startDate;
        updatedPromotion.endDate = formDate?.endDate;
      }

      updatedPromotion.name = form.name;
      updatedPromotion.description = form7.description;
       // promotion publique ou non
       let isPublic = this.promotionFormEdite.controls['promotionForm9'].value;
       let numberMaxAchat = this.promotionFormEdite.controls['promotionForm12'].value.maximumNumberOfPurchases
       updatedPromotion.publicPromotionVisibility = isPublic.isPromotionPublic
       updatedPromotion.isApplyToAll  = this.promotionFormEdite.controls['promotionForm11'].value.isApplyToAll;
       updatedPromotion.maximumNumberOfPurchases = numberMaxAchat
      promotionItem.name = form.name+"Réduction de "+form2.param0 +" FCFA sur les frais de déplacement.";
      promotionItem.typeOffer = this.selectedOfferType;
      promotionItem.value0 = form2.param0;
      promotionItems.push(promotionItem);

      updatedPromotion.promotionItem = promotionItems;
     // console.log("Promo modifiée avec reduction_de_x_montant_sur_les_frais_de_deplacement...");
     // console.log(updatedPromotion);
      this.promotionService.updatePromotion(updatedPromotion).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'La promotion a été modifiée avec succès.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
        //console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 1500
        });
      });
    }
  }

  onpublicPromotionVisibilityFormSubmit(): void{
    if(this.promotionEditVisibilityForm.valid){
      let promo = new Promotion();
      promo.id = this.currentPromotion.id;
      promo.publicPromotionVisibility = this.promotionEditVisibilityForm.controls['publicPromotionVisibility'].value
      promo.maximumNumberOfPurchases =  this.promotionEditVisibilityForm.controls['maximumNumberOfPurchases'].value
        // console.log("Saved Edit promotion visibility...");
        // console.log(promo);
        // console.log("Saved post promotion...");
        // console.log(promo);
      this.promotionService.updatePromotionVisibility(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Votre promotion a été modifiée avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 4500
        });
      });
    }else{
      //console.log("invalide form")
     // console.log(this.postPromotionForm.controls)
    }
  }

  onPostPromotionFormSubmit(): void{
    if(this.postPromotionForm.valid && !this.startDateNotAfterEndDate){
      let promo = new Promotion();
      promo.id = this.selectedPromotion.id;
      promo.promotionItem = this.selectedPromotion.promotionItem
      promo.startDate = this.postPromotionForm.controls['startDate'].value;
      promo.endDate = this.postPromotionForm.controls['endDate'].value;
      promo.publicPromotionVisibility = this.postPromotionForm.controls['publicPromotionVisibility'].value
      promo.isApplyToAll = this.postPromotionForm.controls['isApplyToAll'].value
      let maximumNumber =  this.postPromotionForm.controls['maximumNumberOfPurchases'].value
      if(maximumNumber == null || maximumNumber == '' || Number(maximumNumber) <= 0){
        promo.maximumNumberOfPurchases =  0;
      }else{
        promo.maximumNumberOfPurchases =  Number(maximumNumber);
      }
    //  console.log("Saved post promotion...");
    //  console.log(promo);
      this.postPromotionService.validKahpooPostPromotion(promo).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Votre promotion a été appliquée avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
      //  console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 4500
        });
      });
    }else{
      //console.log("invalide form")
    //  console.log(this.postPromotionForm.controls)
    }
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.perPage);
  }

  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  searchFilter($event: KeyboardEvent) {
    this.allPromotions =  this.allPromotionsTmp.filter(
      value => value.name?.toLowerCase().includes(this.search) ||
      value.type?.toString().includes(this.search) ||
      value.promotionItem[0].typeOffer?.name?.toString().includes(this.search)
    );
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  deletePromotion(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez vous vraiment supprimer cette promotion ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.promotionService.deletePromotion(id).subscribe(
          rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La promotion a été supprimée avec succès',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadPromotions();
        },error =>{
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 4500
          });
        });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })
  }


  sort1() {
    if(this.sorted == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted = false;
    }
  }

  sort2() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.name > b?.name ? 1 : a?.name < b?.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a?.name < b?.name ? 1 : a?.name > b?.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort3() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.promotionItem[0].typeOffer.type > b.promotionItem[0].typeOffer.type ? 1 : a.promotionItem[0].typeOffer.type < b.promotionItem[0].typeOffer.type ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.promotionItem[0].typeOffer.type < b.promotionItem[0].typeOffer.type ? 1 : a.promotionItem[0].typeOffer.type > b.promotionItem[0].typeOffer.type ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort4() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.promotionItem[0].typeOffer.name > b.promotionItem[0].typeOffer.name ? 1 : a.promotionItem[0].typeOffer.name < b.promotionItem[0].typeOffer.name ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.promotionItem[0].typeOffer.name < b.promotionItem[0].typeOffer.name ? 1 : a.promotionItem[0].typeOffer.name > b.promotionItem[0].typeOffer.name ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort5() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.status > b.status ? 1 : a.status < b.status ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.allPromotions.sort((a, b) => a.status < b.status ? 1 : a.status > b.status ? -1 : 0)
      this.sorted4 = false;
    }
  }

  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}

  strUcFirst1(valeur: any) {
    if (valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer?.name) {
      return valeur.promotionItem[0].typeOffer.name;
    } else {
      // Gérer le cas où l'une des propriétés est undefined
      return "La propriété est indéfinie ou n'a pas la structure attendue";
    }
  }

  strUcFirstName(valeur: any) {
    if (valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer?.type) {
      return valeur.promotionItem[0].typeOffer.type;
    } else {
      // Gérer le cas où l'une des propriétés est undefined
      return "La propriété est indéfinie ou n'a pas la structure attendue";
    }
  }

  strUcFirst2(valeur : any){
    if(valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer?.slug){
      return valeur?.promotionItem[0]?.typeOffer?.slug;
    }
  }

  strUcFirst22(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value0
    }
  }

  strUcFirst33(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value1
    }
  }

  strUcFirst44(valeur : any){
    if(valeur != undefined){
      return valeur?.promotionItem[0]?.value2
    }
  }


  strUcFirst3(valeur : any){
    if(valeur != undefined && valeur?.promotionItem?.[0]?.typeOffer){
      return valeur?.promotionItem[0]?.typeOffer;
    }
  }
  isApplyToAll(p: any): boolean {
      return p.publicPromotionVisibility == "ALL"
  }
  strUcFirstPromo(valeur : any){
    if(valeur != undefined){
      return valeur?.codePromo;
    }
  }
  copied = false;
  copiedCode: string = ''; // Ajoutez cette ligne pour stocker le code promo copié

  copyToClipboard(content: string) {
    const textArea = document.createElement('textarea');
    textArea.value = content;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    this.copied = true;
    this.copiedCode = content; // Stocke le code promo copié

    setTimeout(() => {
      this.copied = false;
      this.copiedCode = ''; // Réinitialiser après un délai
    }, 2000);
  }

  strUcFirstPromo2(valeur : any){
    if(valeur != undefined){
      return valeur?.publicPromotionVisibility;
    }
  }

}
